import script from "./systemMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./systemMenu.vue?vue&type=script&setup=true&lang=js"

import "./systemMenu.vue?vue&type=style&index=0&id=e388d738&lang=css"
import "./systemMenu.vue?vue&type=style&index=1&id=e388d738&lang=css"
import "./systemMenu.vue?vue&type=style&index=2&id=e388d738&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e388d738"]])

export default __exports__